import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  listWrapper: {
    padding: theme.spacing(1),
    overflowX: 'auto',
    display: 'flex',
    gap: theme.spacing(1.25),
  },
  itemContainer: {
    padding: theme.spacing(1.25),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
  },
  itemLeftSection: {
    position: 'relative',
    borderRadius: '50%',
    borderWidth: 7,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.lighter,
  },
  itemRightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
}));
